<template>
  <v-container fluid class="pa-0 container-X-max">
    <slot name="ad-leaderboard">
      <ad-leaderboard></ad-leaderboard>
    </slot>
    <home-hero-alt v-if="alternative" :featured-posts="featuredPosts"></home-hero-alt>
    <home-hero v-else :featured-posts="featuredPosts"></home-hero>
    <home-media :excluded-ids="excludedIds"></home-media>
    <slot name="ad-middleboard">
      <ad-mid-leaderboard></ad-mid-leaderboard>
    </slot>
    <v-container class="container--max pa-0">
      <v-row>
        <v-col cols="12" md="8" lg="9">
          <home-tory-diary
            :excluded-ids="excludedIds" 
            :category-ids="toryDiaryIDs"
          ></home-tory-diary>
          <home-comment
            :excluded-ids="excludedIds"
            :category-ids="commentIDs"
          ></home-comment>
          <home-government
            :excluded-ids="excludedIds"
            :category-ids="governmentIDs"
          ></home-government>
        </v-col>
        <v-col cols="12" md="4" lg="3" class="py-12">
          <slot name="sidebar"></slot>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
  export default {
    name: 'AppHomeThree',

    mixins: [
      require('./home.js').default
    ],

    props: {
      // alternative: {
      //   type: Boolean,
      //   default: false
      // },
      // featuredPosts: {
      //   type: Array,
      //   default: () => ([])
      // },
      numberOfItems: {
        type: Number,
        default: 4
      }
    },

    computed: {
      // featuredPost() {
      //   return _.head(this.featuredPosts)
      // },
      // otherItems() {
      //   return this.featuredPosts.slice(1,this.numberOfItems)
      // },
      // excludedIds() {
      //   return _.map(this.featuredPosts, 'id')
      // }
    },

    components: {
      'home-comment': require('./home/Comment.vue').default,
      'home-government': require('./home/Government.vue').default,
      'home-hero': require('./home/HeroThree.vue').default,
      'home-hero-alt': require('./home/HeroThreeAlt.vue').default,
      // 'home-highlights': require('./home/Highlights.vue').default,
      'home-media': require('./home/Media.vue').default,
      'home-tory-diary': require('./home/ToryDiary.vue').default,
    },

  }
</script>
